<div mat-dialog-title class="dialog-title" translate>MAIN_MENU_FILE-SHARE</div>
<div class="dialog-subtitle-row">
    <mat-icon>{{shellStateService.getTypeIcon(docType+'')}}</mat-icon>
    <div class="dialog-subtitle" [matTooltip]="docName">{{docName}}</div>
</div>

<mat-divider></mat-divider>

<div mat-dialog-content class="share-detail-container">
    <div class="share-detail-row">
        <mat-icon class="share-detail-icon">eye_tracking</mat-icon>
        <span class="share-detail-text">{{descViews}}</span>
    </div>
    <div class="share-detail-row">
        <mat-icon class="share-detail-icon">file_copy</mat-icon>
        <span class="share-detail-text">{{descCopies}}</span>
    </div>
    <div class="share-detail-row">
        <mat-icon class="share-detail-icon">group</mat-icon>
        <span class="share-detail-text">{{descPeopleShared}}</span>
    </div>
    <div class="share-detail-row">
        <mat-icon class="share-detail-icon">{{iconShareType}}</mat-icon>
        <span class="share-detail-text">{{descShareType}}</span>
    </div>
</div>

<button class="close-button" mat-icon-button [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
</button>